import React from "react";
import { Snackbar, Alert } from "@mui/material";

interface ToastProps {
  message: string;
  severity: "success" | "error" | "warning" | "info";
  open: boolean;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, severity, open, onClose }) => {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      onClose();
    } else if (reason === "timeout") {
      // fire onClose function even when snackbar autocloses
      // this is for cleaner state management (i.e. still update parent's "open" bool)
      onClose();
    }
  };
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ top: "150px" }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
